type Mammoth = typeof import("mammoth");

let pending: Promise<Mammoth> | null = null;

/**
 * Loads mammoth on first use and caches the result.
 *
 * mammoth is ~940 KB and is only needed to pull text out of a .docx upload, so
 * importing it eagerly put it on the critical path of every page — including
 * login, which never touches a Word file.
 *
 * Concurrent callers share one in-flight import. `window.mammoth` is still set
 * once resolved, because legacy code reads it from there.
 */
export function ensureMammoth(): Promise<Mammoth> {
  if (!pending) {
    pending = import("mammoth")
      .then((mod) => {
        const lib = (mod.default ?? mod) as Mammoth;
        if (typeof window !== "undefined") {
          window.mammoth = lib as unknown as Window["mammoth"];
        }
        return lib;
      })
      .catch((err) => {
        /* Let the next caller retry rather than caching the failure. */
        pending = null;
        throw err;
      });
  }
  return pending;
}
